import Zendesk from "helpers/Zendesk";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAppSelector } from "redux/hooks";
import RequestStatus from "redux/slices/RequestStatus";
import { selectSession, selectSessionStatus } from "redux/slices/session";

export default function ProtectedRoute() {
  const location = useLocation();
  const session = useAppSelector(selectSession);
  const sessionStatus = useAppSelector(selectSessionStatus);
  if (!session && sessionStatus !== RequestStatus.PENDING && sessionStatus !== RequestStatus.IDLE) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  useEffect(() => {
    const url = "https://static.zdassets.com/ekr/snippet.js?key=0bd823fd-a53b-4414-8ee1-c0db87bc8ff4";

    const script = document.querySelector(`script[src="${url}"]`);

    if (!script) {
      const newScript: HTMLScriptElement = document.createElement("script");
      newScript.type = "application/javascript";
      newScript.src = url;
      newScript.async = true;
      newScript.id = "ze-snippet";
      newScript.onload = () => {
        Zendesk.hide();
        Zendesk.registerHideOnClose();
      };
      document.body.appendChild(newScript);
    }
  }, []);

  return <Outlet />;
}
